import { useAbility as useCaslAbility } from "@casl/react";

import { Ability } from "../models/permissions";

export function useAbility() {
  return useCaslAbility<Ability>();
}
